var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui item",on:{"click":function($event){return _vm.addIngredient(_vm.source)}}},[_c('span',{staticClass:"result"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.source.label))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }